<template>
  <v-card>
    <v-card-title>
      #{{name + 1}}
    </v-card-title>
    <v-card-text>
      <PulseResultForm ref="form" :result="result" :edit="edit" :points="points" :types="types" />
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn v-if="edit" color="primary darken-1" key="cancel" text @click="edit = false">
				<translate>Cancel</translate>
			</v-btn>
      <v-btn v-else color="primary darken-1" key="remove" text @click="showRemoveResult = true">
				<translate>Remove</translate>
        <DeleteConfirmationDialog v-model="showRemoveResult" item="result" @delete="removeResult" />
			</v-btn>
      <v-spacer></v-spacer>
      <v-btn v-if="!edit" color="primary darken-1" key="edit" text @click="edit = !edit">
				<translate>Edit</translate>
			</v-btn>
      <v-btn v-else color="primary darken-1" key="save" text @click="saveResult" :loading="saveResultLoading">
				<translate>Save</translate>
			</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import PulseResultForm from "@/components/admin/PulseResultForm.vue";
import DeleteConfirmationDialog from "@/components/DeleteConfirmationDialog.vue";
import axios from "axios";

export default {
  name: "PulseResult",
  props: ["result", "name", "points", "types"],
  components: {
    PulseResultForm,
    DeleteConfirmationDialog
  },
  data: () => ({
    edit: false,
    showRemoveResult: false,
    saveResultLoading: false
  }),
  methods: {
    saveResult() {
      this.saveResultLoading = true;
      axios
        .post("/admin/pulse-results/" + this.result.id + "/edit", this.result)
        .then(response => {
          console.log(response.data);
          this.edit = false;
          this.$refs.form.reset();
          this.saveResultLoading = false;
        })
        .catch(error => {
          console.log(error);
          this.saveResultLoading = false;
        });
    },
    removeResult() {
      axios
        .post("/admin/pulse-results/" + this.result.id + "/delete")
        .then(response => {
          console.log(response.data);
          this.$emit("remove-result", this.result);
          this.showRemoveResult = false;
        })
        .catch(error => {
          console.log(error);
          this.addResultLoading = false;
        });
    }
  },
  created() {
    console.log(this.result);
  }
}
</script>